export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "close": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])}
      },
      "fr": {
        "close": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer"])}
      }
    }
  })
}
